<script lang="ts" setup>
import type { Glossary } from '~/models/Richtext/Glossary'
import AuPopover from '~/components/ui/AuPopover.vue'

const { word, glossary } = defineProps<{
  word?: string
  glossary?: Glossary
}>()
</script>

<template>
  <AuPopover side="top" align="start">
    <template #trigger>
      <button class="transition hover:bg-black/5 focus-visible:ring">
        <abbr
          v-dompurify-html="word"
          :title="glossary?.explanation ?? ''"
        />
      </button>
    </template>
    <template #content>
      <div class="flex flex-col gap-1 p-2 *:m-0">
        <p v-dompurify-html="glossary?.title ?? ''" class="text-xl font-bold" />
        <p v-dompurify-html="glossary?.explanation ?? ''" class="max-w-[33ch] text-base" />
      </div>
    </template>
  </AuPopover>
</template>
